var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 38.889,
    viewBox: "0 0 35 38.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-912.871 -3017.085)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(912.871 3038.974)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(930.871 3017.085)",
    fill: "#0533b3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.361,1035.135c-.461.462.414,1.354.872.888l.713-.727v3.917a5.178,5.178,0,0,1-5.175,5.234l-3.574.052a.626.626,0,0,0,0,1.252l3.574-.051a6.446,6.446,0,0,0,6.409-6.486v-3.874l.67.683c.456.466,1.334-.426.872-.888-2.217-2.48-2.153-2.24-4.361,0Z",
    transform: "translate(909.422 2002.057)",
    fill: "#0533b3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.064,1043.98c.461-.463-.414-1.355-.872-.888l-.713.727V1039.9a5.178,5.178,0,0,1,5.175-5.234l3.574-.052a.626.626,0,0,0,0-1.252l-3.574.052a6.446,6.446,0,0,0-6.409,6.486v3.874l-.67-.683c-.456-.466-1.334.426-.872.888,2.217,2.479,2.153,2.24,4.361,0Z",
    transform: "translate(893.929 1991.648)",
    fill: "#0533b3",
    fillRule: "evenodd",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversion);
export default __webpack_public_path__ + "static/media/conversion.a6cad18cd73ebdb25d0f647c3d86f701.svg";
export { ForwardRef as ReactComponent };